import seoInformation from '../SeoInformation/SeoInformation';
import Popup from "../UiKit/Elements/Popup/Popup";
import './Companies.scss';

const initSorting = () => {
  [].forEach.call(document.querySelectorAll('[data-order]'), (node) => {
    node.addEventListener('click', (event) => {
      event.preventDefault();
      node.classList.add('-selected');
      window.location.replace(node.href);
    });
  });

  new Popup('sorting');
};

seoInformation();
initSorting();
